import { useEffect, useState } from "react";
import { SnapLoader } from "./snap-loader";

function AppLoading() {
  const [textEnabled, setTextEnabled] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setTextEnabled(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full h-screen">
      <div className="flex justify-center items-center h-full my-auto">
        <div>
          <SnapLoader />
          {textEnabled && (
            <h1 className="text-2xl mt-10" id="snap-right-path">
              Thank you for your patience while we retrieve your information...
            </h1>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppLoading;
